<template>
  <CommonDialog
    :dialog.sync="dialog"
    :on-cancel="close"
    :on-confirm="callExport"
    :head-text="$t('documents.export')"
    :confirm-button="{
      text: $t('documents.export'),
      icon: 'mdi-download-outline'
    }"
    :selected.sync="selected"
  >
    <v-form ref="form">
      <v-row>
        <v-col cols="12" class="py-2">
          {{ $tc("documents.export-about", selected.length) }}
        </v-col>
        <v-col class="py-0" cols="12" sm="12">
          <v-checkbox
            v-if="draftCount"
            class="py-0"
            v-model="final"
            color="primary"
            :label="$tc('documents.from-draft-to-finalized', draftCount)"
          ></v-checkbox>
        </v-col>
        <v-col class="py-0" cols="12" sm="12">
          <v-autocomplete
            class="py-0"
            v-model="status"
            :items="statuses"
            :label="$t('documents.status')"
            item-text="name"
            item-value="id"
            :disabled="!isAllSelectedInOneType"
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>
  </CommonDialog>
</template>

<script>
import CommonDialog from "../common/dialogs/CommonDialog";
import { permissions } from "../mixins/permissions";

export default {
  mixins: [permissions],
  name: "DialogForMassExport",
  components: { CommonDialog },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function() {
        return [];
      }
    },
    onSuccess: {
      type: Function,
      default: function() {
        return function() {};
      }
    },
    permission: {
      type: String
    },
    permissionsItemKey: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    final: false,
    status: null
  }),
  computed: {
    type_id: {
      get() {
        return (
          (((this.selected[0] || {})._template || {})._type || {}).id ||
          "consumption-bill"
        );
      }
    },
    type() {
      if (this.type_id) {
        return this.types.find(e => e.id === this.type_id) || {};
      }
      return {};
    },
    statuses() {
      return (
        ((this.selected[0] && this.selected[0]._template._type) || {})
          .statuses || []
      );
    },
    types: {
      get() {
        return this.$store.getters["documentTypeStore/getList"];
      }
    },
    draftCount() {
      return (this.selected || []).reduce((ac, i) => {
        return ac + i.draft;
      }, 0);
    },
    isAllSelectedInOneType() {
      return (
        !!this.selected.length &&
        this.selected.filter(
          i => i._template._type.id === this.selected[0]._template._type.id
        ).length === this.selected.length
      );
    }
  },
  methods: {
    callExport() {
      let selected = this.getAllLegalSelected(this.permission);
      if (!selected && !selected.length) {
        return;
      }
      this.close();
      this.setLoading(true);
      let callback = () =>
        this.$store.dispatch("documentStore/massExport", {
          ids: selected.map(i => i.id),
          onSuccess: () => {
            this.setLoading(false);
            this.onSuccess();
          },
          onError: () => {
            this.setLoading(false);
          }
        });
      let values = {};
      if (this.status) {
        values.status = this.status;
      }
      if (this.final) {
        values.draft = false;
      }
      if (Object.keys(values)) {
        this.$store.dispatch("documentStore/updateList", {
          values,
          ids: this.selected.map(i => i.id),
          onSuccess: callback
        });
      } else {
        callback();
      }
    },
    getAllLegalSelected(role) {
      let items = this.selected.filter(i => !i.isWillRemoveSoon);
      let len = items.length;
      if (role) {
        items = items.filter(i => {
          return this.hasPermissions(
            this.permissionsItemKey ? i[this.permissionsItemKey] : i,
            role
          );
        });
      }
      if (items.length !== len) {
        this.$store.dispatch("notificationStore/createNotification", {
          text: this.$i18n.t("message.actions-could-not-be-processed"),
          type: "warning",
          value: true
        });
      }
      return items;
    },
    close() {
      this.$emit("update:dialog", false);
    },
    setLoading(val) {
      this.$emit("update:loading", val);
    }
  }
};
</script>

<style scoped></style>
